import globalColors from '@data/variables/global-colors';

function customers () {
	const elId = '#app-customers';
	const elClass = '.js-vue-customers';

	if ($(elId).length == 0 || $(elClass).length == 0) {
		return;
	}

	const headerHandicap = 1;

	const app = new Vue({
		el: elId,
		data: {
			search: {
				filter: null,
				field: null,
				fieldoption: null,
				currentkeyword: null
			},
			history: [],
			results: {
				count: 0,
				items: [],
				selected: null,
				expansions: null
			},
			pagination: {
				max: 999,
				pagesize: 10,
				currentpage: 0
			},
			spider: {
				hide: false,
				loaded: false,
				request: null,
				response: null,
				data: null
			},
			chart: null,
			settings: {
				showAllTags: false,
				showExtraTags: [],
				showAllInfo: false,
				loadedAllExpansions: false
			},
			expanded: false,
			error: null,
			languages: [],
			genders: [],
			countries: [],
			config: [],
			actions: [],
			tags: [],
			searchoptions: [],
			customerViewComponent: null,
			componentmodal: null
		},
		filters: {
			formatCount: function (c) {
				return c >= 100 ? `${c}+` : c;
			}
		},
		created: function () {
			const self = this;
			self.customerViewComponent = {
				component: 'nominow-customer-view',
				parent: self
			};
			const starthash = document.location.hash;
			if (starthash) {
				document.location.hash = '';
				this.search.field = starthash.substring(1);
				this.doSearch();
			}
			GETCACHEDSESSION('/baas/nominow_insight/admin/tags?projection={TagCode:1,TagName:1}').then(xhr => {
				const response = JSON.parse(xhr.responseText);
				console.log(response);
				self.tags = response;
			});

			GETCACHEDSESSION('/baas/nominow_management/uiexpansions')
				.then(xhr => {
					self.error = null;
					const response = JSON.parse(xhr.responseText);
					const customer = Array.prototype.find.call(
						response,
						p => p.page == 'Customers'
					);
					// var moduleResponse = customer.ModuleItems[0];
					// find customerview
					const view = Array.prototype.find.call(
						customer.actions,
						a => a.name == 'View'
					);
					if (view) {
						const indexView = customer.actions.indexOf(view);
						customer.actions.splice(indexView, 1);
						if (
							view.componentCode != null &&
							view.componentCode != '' &&
							Vue.options.components[view.component] == null
						) {
							// NOTE register components
							$('body').append(
								`<script id="scriptfor-${
								view.component
								}">Vue.component("${view.component}", ${
								view.componentCode
								})</script>`
							);
						}
						// self.customerViewComponent = view.component;
						self.customerViewComponent = {
							component: view.component,
							parent: self
						};
					}

					self.actions = customer.actions;
					self.config = customer.extraInfo;
					for (let i = 0; i < self.config.length; i++) {
						Vue.set(showExtraTags, i, false);
					}
					$(elClass).removeClass('is-creating');
					toggleLoader(false);
				})
				.catch(xhr => {
					self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
					$(elClass).removeClass('is-creating');
					toggleLoader(false);
				});
			GETCACHEDSESSION('/baas/Nominow_CustomerManagement/languages')
				.then(xhr => {
					self.error = null;
					const response = JSON.parse(xhr.responseText);
					self.languages = response;
				})
				.catch(xhr => {
					self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
				});
			GETCACHEDSESSION('/baas/Nominow_CustomerManagement/genders')
				.then(xhr => {
					self.error = null;
					const response = JSON.parse(xhr.responseText);
					self.genders = response;
				})
				.catch(xhr => {
					self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
				});

			GETCACHEDSESSION('/baas/Nominow_CustomerManagement/countries')
				.then(xhr => {
					self.error = null;
					const response = JSON.parse(xhr.responseText);
					self.countries = response;
				})
				.catch(xhr => {
					self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
				});

			GETCACHEDSESSION('/baas/Nominow_CustomerManagement/searchoptions')
				.then(xhr => {
					const result = JSON.parse(xhr.responseText);
					self.searchoptions = result;
					self.fillSearchOptions();
				})
				.catch(() => {
					self.searchoptions = [];
					self.fillSearchOptions();
				});

			window.onpopstate = function (event) {
				console.log(
					`location: ${document.location}, state: ${JSON.stringify(
						event.state
					)}`
				);
				if (event && event.state && event.state.page == 'contact') {
					self.refreshItem(event.state.guid);
				} else {
					// console.log('back!!!!!!!!!!!!');
					self.results.selected = null;
					self.results.expansions = [];
					self.settings.showAllInfo = false;
					self.settings.loadedAllExpansions = false;
					Vue.nextTick(function () { self.fillSearchOptions(); });
				}
			};

			if (history && history.state && history.state.page == 'contact') {
				this.refreshItem(history.state.guid);
			}

			const hist = localStorage.getItem('searchHistory');
			if (hist != null) {
				self.history = JSON.parse(hist);
			}
		},
		mounted: function () {
			$(elClass).removeClass('is-mounting');
		},
		methods: {
			getTagName: function (item) {
				const code = item['Profile tag'];
				for (let i = 0; i < this.tags.length; i++) {
					if (this.tags[i].TagCode == code) {
						return this.tags[i].TagName;
					}
				}
				return code;
			},
			addHistoryItem: function (keyword, count) {
				if (this.history == null) {
					this.history = [];
				}
				for (let i = this.history.length - 1; i >= 0; i--) {
					if (this.history[i].keyword == keyword) {
						this.history.splice(i, 1);
					}
				}
				this.history.unshift({
					keyword: keyword,
					date: new Date().getTime(),
					count: count
				});
				this.history = this.history.slice(0, 10);
				localStorage.setItem(
					'searchHistory',
					JSON.stringify(this.history)
				);
			},
			deleteHistoryItem: function (ix) {
				this.history.splice(ix, 1);
				localStorage.setItem(
					'searchHistory',
					JSON.stringify(this.history)
				);
			},
			doHistorySearch: function (item) {
				if (item.keyword.indexOf(':') > 0) {
					const items = item.keyword.split(':');
					this.search.field = items[1];
					this.search.fieldoption = items[0];
				} else {
					this.search.field = item.keyword;
				}
				this.doSearch();
			},
			fillSearchOptions: function () {
				const $el = $('#searchOptions');
				if (this.searchoptions && this.searchoptions.length > 0) {
					this.search.fieldoption = '';
					$('select', $el).append('<option value="">All fields</option>');
					for (let i = 0; i < this.searchoptions.length; i++) {
						const option = this.searchoptions[i];
						$('select', $el).append(`<option value="${option.key}">${option.value}</option>`);
					}
					$el.removeClass('is-hidden');
				} else {
					$el.addClass('is-hidden');
				}
			},
			getGender: function (val) {
				for (let i = 0; i < this.genders.length; i++) {
					if (this.genders[i].GenderId == val || this.genders[i].GenderCode == val) {
						return this.genders[i].GenderDescription;
					}
				}
				return 'Unknown';
			},
			getLanguage: function (val) {
				for (let i = 0; i < this.languages.length; i++) {
					if (this.languages[i].LanguageId == val || this.languages[i].LanguageCode == val) {
						return this.languages[i].LanguageName;
					}
				}
				return 'Unknown';
			},
			getCountry: function (val) {
				for (let i = 0; i < this.countries.length; i++) {
					if (this.countries[i].CountryId == val || this.countries[i].CountryCode == val) {
						return this.countries[i].CountryName;
					}
				}
				return 'Unknown';
			},
			doSearch: function () {
				const self = this;
				if (window.isLoading() || self.search.field == null) {
					return;
				}
				toggleLoader(true);

				let search = self.search.field.toLowerCase();
				self.pagination.currentpage = 0;
				if (!search) {
					self.search.currentkeyword = null;
					self.results.items = [];
					self.results.count = 0;
					self.error = null;
					toggleLoader(false);
				} else {
					if (self.search.fieldoption) {
						search = `${self.search.fieldoption}:${search}`;
					}
					GET(`/baas/Nominow_CustomerManagement/contact/search?keyword=${search}`)
						.then(xhr => {
							self.error = null;
							const items = JSON.parse(xhr.responseText);
							if (items != null && items != []) {
								self.results.items = items;
								self.results.count =
									items.length - headerHandicap;
							} else {
								self.results.items = [];
								self.results.count = 0;
							}
							self.search.currentkeyword = self.search.field;

							self.addHistoryItem(search, self.results.count);
							toggleLoader(false);
						})
						.catch(xhr => {
							self.results.items = [];
							self.results.count = 0;
							let errorMessage = timeOutResponseText;
							if (xhr.responseText) {
								const resultObj = JSON.parse(xhr.responseText);
								if (resultObj && resultObj.Message) {
									errorMessage = resultObj.Message;
								}
							}
							self.error = errorMessage;
							toggleLoader(false);
						});
				}
			},
			refreshItem: function (guid) {
				if (window.isLoading()) {
					return;
				}
				toggleLoader(true);
				const self = this;
				GET(`/baas/Nominow_CustomerManagement/contact?ContactGuid=${guid}`)
					.then(xhr => {
						self.error = null;
						const itemStr = xhr.responseText;
						const obj = JSON.parse(itemStr);
						self.results.selected = obj;
						self.chart = null;
						self.results.expansions = [];
						self.settings.showAllInfo = false;
						self.settings.loadedAllExpansions = false;

						self.loadChart();
						// load all tags now
						for (let i = 0; i < self.config.length; i++) {
							console.log('expansion', self.config[i].controlType);
							if (self.config[i].controlType == 'Tag') {
								self.loadExpansion(i);
							}
						}
						toggleLoader(false);
					})
					.catch(xhr => {
						self.error =
							xhr.responseText != ''
								? xhr.responseText
								: timeOutResponseText;
						toggleLoader(false);
					});
			},
			selectItem: function (item, ix) {
				const contactGuid = item.ContactGuid;
				// levarage history
				history.pushState({ page: 'contact', guid: contactGuid }, 'Detail - Customers - Nominow', '/app/customers/contact');
				this.refreshItem(contactGuid);
			},
			deselectItem: function (hist) {
				// see the history.onpopstate in the "created" function above
				history.go(-1);
			},
			loadChart: function () {
				const self = this;
				const contactGuid = self.results.selected.ContactGuid;
				self.spider.loaded = false;
				self.spider.response = null;
				GET(`/baas/Nominow_CustomerManagement/contact/spider?ContactGuid=${contactGuid}`)
					.then(xhr => {
						self.error = null;
						const response = JSON.parse(xhr.responseText);
						response.ValueTitle = 'Customer';
						self.spider.response = response;
						self.spider.hide = false;
						self.spider.loaded = true;
						vuelog('spider', self.spider);
					})
					.catch(xhr => {
						self.spider.loaded = false;
						self.spider.hide = true;
						console.error(
							'failed to load spider',
							xhr.responseText
						);
					});
			},
			btnToggleFullProfile: function () {
				const self = this;
				self.settings.showAllInfo = !self.settings.showAllInfo;
				if (self.settings.loadedAllExpansions) {
					return;
				}
				$.each(self.config, (i, element) => {
					self.loadExpansion(i);
				});
				self.settings.loadedAllExpansions = true;
			},
			loadExpansion: function (i) {
				const self = this;

				const contactGuid = self.results.selected.ContactGuid;
				const configExpansion = self.config[i];

				GET(`/baas/Nominow_CustomerManagement/${configExpansion.endpoint}?ContactGuid=${contactGuid}`)
					.then(xhr => {
						const exp = {
							results: [],
							error: null,
							pagination: {
								pagesize: 10,
								currentpage: 0,
								max: 9999
							},
							name: configExpansion.name
						};

						const result = JSON.parse(xhr.responseText);

						exp.results = result;
						Vue.set(self.results.expansions, i, exp);
						if (i == self.config.length - 1) {
							toggleLoader(false);
						}
					})
					.catch(xhr => {
						const exp = {
							results: [],
							error: null,
							name: configExpansion.Name
						};

						const obj = JSON.parse(xhr.responseText);
						if (obj && obj.Message != null) {
							exp.error = obj.Message;
						} else {
							exp.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
						}
						Vue.set(self.results.expansions, i, exp);
						if (i == self.config.Expansion.length - 1) {
							toggleLoader(false);
						}
					});
			},
			selectAction: function (action, ix) {
				if (
					action.componentCode != null &&
					action.componentCode != '' &&
					Vue.options.components[action.component] == null
				) {
					// NOTE register components
					$('body').append(
						`<script id="scriptfor-${
						action.component
						}">Vue.component("${action.component}", ${
						action.componentCode
						})</script>`
					);
				}

				this.componentmodal = {
					title: action.name,
					component: action.component,
					data: this.results.selected,
					parent: this
				};
			},
			closemodals: function () {
				this.componentmodal = null;
			},
			selectExpansionItem: function (item, ix, expansionIx) {
				const self = this;
				const expansion = this.config[expansionIx];
				if (expansion.Detailendpoint) {
					GET(`/baas/Nominow_CustomerManagement/${expansion.Detailendpoint}?Id=${item[expansion.ShowDetailId]}`)
						.then(xhr => {
							const result = JSON.parse(xhr.responseText);
							self.componentmodal = {
								title: 'Detailed',
								component: 'nominow-table-detail-result',
								isLarge: true,
								data: {
									items: result,
									message: null
								}
							};
						})
						.catch(trapError);
				}
			},
			btnExportChart: function (option) {
				if (this.chart == null || this.chart.chart == null) {
					return;
				}
				/* See documentation https://api.highcharts.com/class-reference/Highcharts.Chart.html#exportChart */
				const chartOptions = {
					pane: {
						background: {
							backgroundColor: 'transparent'
						}
					},
					xAxis: {
						labels: {
							style: {
								color: globalColors.primary.hue1
							}
						}
					},
					legend: {
						itemStyle: {
							color: globalColors.primary.hue1
						}
					}
				};
				if (option == 'print') {
					this.chart.chart.print();
				} else if (option == 'png') {
					this.chart.chart.exportChart(
						{ type: 'image/png' },
						chartOptions
					);
				} else if (option == 'jpeg') {
					this.chart.chart.exportChart(
						{ type: 'image/jpeg' },
						chartOptions
					);
				} else if (option == 'pdf') {
					this.chart.chart.exportChart(
						{ type: 'application/pdf' },
						chartOptions
					);
				} else if (option == 'svg') {
					this.chart.chart.exportChart(
						{ type: 'image/svg+xml' },
						chartOptions
					);
				} else {
					this.chart.chart.print();
				}
			}
		}
	});
	/* App is added as window.activeRootComponent so that it can be used by helpers, such as the keyup helper. */
	window.activeRootComponent = app;
}
customers();
